import { render, staticRenderFns, recyclableRender, components } from "./register.vue?vue&type=template&id=417ad080&scoped=true&"
var renderjs
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=417ad080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ad080",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/login/register/register.vue"
export default component.exports